import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { GlobalService } from './global.service';
import { OrganizationType } from '../models/staff/organization-type.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private globalService: GlobalService,
    private message: NzMessageService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (state.url.indexOf('login') > -1) {
      return true;
    } else {
      if (!this.globalService.isLogin && state.url.indexOf('/open/') === -1) {
        if (state.url === '/signin') {
          return true;
        } else {
          this.router.navigate(['/signin']);
          return false;
        }
      } else {
        return this.checkByAudit(route, state);
      }
    }
  }

  private checkByAudit(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (
      state.url === '/signin' ||
      state.url === '/not-found' ||
      state.url === '/login'
    ) {
      this.router.navigate(['/']);
      return false;
    } else {
      if (
        state.url === '/home/notice' ||
        state.url.indexOf('/preview') > -1 ||
        state.url.indexOf('/sign') > -1 ||
        state.url.indexOf('/custom-form') > -1 ||
        state.url.indexOf('/entity') > -1
      ) {
        return true;
      } else {
        if (
          state.url.indexOf('/operations-manage') > -1 &&
          this.globalService.userInfo.organizationType ===
            OrganizationType.OPERATE
        ) {
          return true;
        }
        if (state.url.indexOf('/open') === 0) {
          if (state.url.indexOf('/operations-manage/forms') > -1) {
            this.router.navigateByUrl(
              '/open/home/notice?token=' + this.globalService.outerToken,
            );
            return false;
          }
          console.log('开放平台', state.url);
          return true;
        }
        if (
          state.url.indexOf('/projects-manage/device/category') > -1 &&
          this.globalService.userInfo.organizationType ===
            OrganizationType.OPERATE
        ) {
          return true;
        }
        const testUrl = this.getTestUrl(state.url);
        if (
          !!this.globalService.urlAuditMap &&
          !!this.globalService.urlAuditMap[testUrl] &&
          !!this.globalService.urlAuditMap[testUrl].readAble
        ) {
        } else {
          this.message.error('没有权限！');
          this.router.navigate(['/home']);
          return false;
        }
        return true;
      }
    }
  }

  getTestUrl(testUrl: string) {
    const urlList = [
      '/qa/test',
      '/qa/material',
      '/qa/handover',
      '/projects-progress/progress',
      '/projects-manage/worker',
      '/projects-manage/device',
      '/operations-manage/forms',
      '/operations-manage/arch',
      '/operations-manage/pforms/CONSTRUCTION',
      '/operations-manage/pforms/CHECK',
      '/operations-manage/codes',
      '/operations-manage/account',
      '/operations-manage/iot',
      '/operations-manage/overdue',
      '/projects-manage/overdue',
      '/profiles/list',
    ];
    for (const url of urlList) {
      if (testUrl.indexOf(url) > -1) {
        return url;
      }
    }

    return testUrl;
  }
}
